/**
 * Demo Form Handler
 * Handles form validation and submission on book-demo page
 */

// Helper function to update asterisk position
function updateDemoAsteriskPosition(input, asterisk) {
  if (!input || !asterisk) return;
  
  const placeholder = input.getAttribute('placeholder') || '';
  if (!placeholder) return;
  
  // Create a temporary span to measure placeholder text width
  const tempSpan = document.createElement('span');
  tempSpan.style.visibility = 'hidden';
  tempSpan.style.position = 'absolute';
  tempSpan.style.whiteSpace = 'nowrap';
  tempSpan.style.fontSize = window.getComputedStyle(input).fontSize;
  tempSpan.style.fontWeight = window.getComputedStyle(input).fontWeight;
  tempSpan.style.fontFamily = window.getComputedStyle(input).fontFamily;
  tempSpan.textContent = placeholder;
  document.body.appendChild(tempSpan);
  
  const placeholderWidth = tempSpan.offsetWidth;
  document.body.removeChild(tempSpan);
  
  // Get input padding and icon offset
  const inputPaddingLeft = parseInt(window.getComputedStyle(input).paddingLeft) || 20;
  const inputIcon = input.parentElement.querySelector('.input-icon');
  const iconOffset = inputIcon ? (inputIcon.offsetWidth + parseInt(window.getComputedStyle(inputIcon).left) || 0) : 0;
  
  // Calculate position: padding left + icon width + placeholder width + small gap
  const leftPosition = inputPaddingLeft + iconOffset + placeholderWidth + 10;
  asterisk.style.left = `${leftPosition}px`;
}

function initDemoForm() {
  const demoForm = document.getElementById('demoForm');

  if (!demoForm) {
    return;
  }

  // Initialize form validation
  initDemoFormValidation();
  
  // Handle form submission
  demoForm.addEventListener('submit', async function (e) {
    e.preventDefault();

    // Clear previous error messages
    clearDemoEmailError();

    // Get form data
    const formData = new FormData(demoForm);
    const firstName = formData.get('firstName') || '';
    const lastName = formData.get('lastName') || '';
    const email = formData.get('email') || '';

    // Validate required fields
    let isValid = true;

    if (!firstName.trim()) {
      const firstNameInput = demoForm.querySelector('#demoFirstName');
      if (firstNameInput) {
        firstNameInput.classList.add('form-control--invalid');
      }
      isValid = false;
    }

    if (!lastName.trim()) {
      const lastNameInput = demoForm.querySelector('#demoLastName');
      if (lastNameInput) {
        lastNameInput.classList.add('form-control--invalid');
      }
      isValid = false;
    }

    if (!email.trim()) {
      showDemoEmailError('Incorrect email');
      isValid = false;
    } else {
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        showDemoEmailError('Incorrect email');
        isValid = false;
      }
    }

    if (!isValid) {
      // Scroll to first error field
      const firstErrorField = demoForm.querySelector('.form-control--invalid');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorField.focus();
      }
      return;
    }

    // Disable submit button
    const submitButton = demoForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.innerHTML;
    submitButton.disabled = true;
    submitButton.innerHTML = '<span>Sending...</span>';

    // Prepare email content
    const subject = 'Demo Request - ElectHQ Platform';
    const body = `
Hello ElectHQ Team,

You have received a new demo request:

Contact Information:
- Name: ${firstName} ${lastName}
- Email: ${email}

Please contact the user to schedule a demo session.

Best regards,
ElectHQ Platform
    `.trim();

    // Get demo email from env
    const demoEmail = window.DEMO_EMAIL || 'demo@vanguardai.net';

    // Send email
    try {
      const res_email = await fetch(`${window.API_BASE_URL || 'https://api.electhq.net'}/api/send-mail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: demoEmail,
          subject: subject,
          content: body
        })
      });

      if (!res_email.ok) {
        const errorData = await res_email.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to send email');
      }

      // Reset form
      demoForm.reset();

      // Show success message
      showDemoSuccessMessage();

      // Re-enable submit button
      submitButton.disabled = false;
      submitButton.innerHTML = originalButtonText;

    } catch (error) {
      console.error('Error sending email:', error);
      
      // Re-enable submit button
      submitButton.disabled = false;
      submitButton.innerHTML = originalButtonText;
      
      // Show error
      alert('An error occurred while sending your request. Please try again.');
    }
  });
}

/**
 * Initialize demo form validation
 */
function initDemoFormValidation() {
  const form = document.getElementById('demoForm');
  if (!form) return;

  const inputs = form.querySelectorAll('input[required]');

  inputs.forEach(input => {
    input.addEventListener('blur', function () {
      validateDemoField(this);
    });

    input.addEventListener('input', function () {
      this.classList.remove('form-control--invalid');
      if (this.name === 'email') {
        clearDemoEmailError();
      } else {
        clearDemoFieldError(this);
      }
    });
  });

  // Handle firstName field
  const firstNameInput = form.querySelector('#demoFirstName');
  if (firstNameInput) {
    firstNameInput.addEventListener('blur', function () {
      validateDemoField(this);
    });
    
    firstNameInput.addEventListener('input', function () {
      this.classList.remove('form-control--invalid');
      clearDemoFieldError(this);
    });
  }
  
  // Handle lastName field
  const lastNameInput = form.querySelector('#demoLastName');
  if (lastNameInput) {
    lastNameInput.addEventListener('blur', function () {
      validateDemoField(this);
    });
    
    lastNameInput.addEventListener('input', function () {
      this.classList.remove('form-control--invalid');
      clearDemoFieldError(this);
    });
  }

  // Handle email field
  const emailInput = form.querySelector('#demoEmail');
  if (emailInput) {
    emailInput.addEventListener('blur', function () {
      validateDemoField(this);
    });
    
    emailInput.addEventListener('input', function () {
      this.classList.remove('form-control--invalid');
      clearDemoEmailError();
    });
  }

  // Handle required asterisk positioning
  const requiredInputs = form.querySelectorAll('input[required]');
  
  requiredInputs.forEach(input => {
    const asterisk = input.parentElement.querySelector('.required-asterisk-inline');
    if (asterisk) {
      // Calculate initial position
      updateDemoAsteriskPosition(input, asterisk);
      
      // Show/hide based on input value
      function updateAsteriskVisibility() {
        if (input.value) {
          asterisk.classList.remove('visible');
        } else {
          asterisk.classList.add('visible');
          updateDemoAsteriskPosition(input, asterisk);
        }
      }
      
      // Initial state
      updateAsteriskVisibility();
      
      // Update on input
      input.addEventListener('input', updateAsteriskVisibility);
      
      // Update on focus/blur
      input.addEventListener('focus', function() {
        if (!this.value) {
          asterisk.classList.add('visible');
          updateDemoAsteriskPosition(input, asterisk);
        }
      });
      
      input.addEventListener('blur', function() {
        if (!this.value) {
          asterisk.classList.add('visible');
          updateDemoAsteriskPosition(input, asterisk);
        }
      });
      
      // Recalculate on window resize
      window.addEventListener('resize', () => {
        if (!input.value) {
          updateDemoAsteriskPosition(input, asterisk);
        }
      });
    }
  });
}

/**
 * Validate demo form field
 */
function validateDemoField(field) {
  const value = field.value.trim();
  const fieldName = field.name;

  // Clear previous error styling and messages
  field.classList.remove('form-control--invalid');
  if (fieldName === 'email') {
    clearDemoEmailError();
  } else {
    clearDemoFieldError(field);
  }

  // Validate based on field type
  if (fieldName === 'email' && value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      field.classList.add('form-control--invalid');
      showDemoEmailError('Incorrect email');
      return false;
    }
  }

  if (field.hasAttribute('required') && !value) {
    field.classList.add('form-control--invalid');
    if (fieldName === 'email') {
      showDemoEmailError('Incorrect email');
    }
    return false;
  }

  return true;
}

/**
 * Show demo email error message
 */
function showDemoEmailError(message) {
  const emailInput = document.getElementById('demoEmail');
  const emailError = document.getElementById('demoEmailError');
  
  if (emailInput) {
    emailInput.classList.add('form-control--invalid');
  }
  
  if (emailError) {
    emailError.textContent = message;
    emailError.style.display = 'block';
    emailError.style.color = '#DC2626';
  }
}

/**
 * Clear demo email error message
 */
function clearDemoEmailError() {
  const emailInput = document.getElementById('demoEmail');
  const emailError = document.getElementById('demoEmailError');
  
  if (emailInput) {
    emailInput.classList.remove('form-control--invalid');
  }
  
  if (emailError) {
    emailError.style.display = 'none';
    emailError.textContent = '';
  }
}

/**
 * Show demo field error styling
 */
function showDemoFieldError(field, message) {
  if (field) {
    field.classList.add('form-control--invalid');
    
    const fieldName = field.name;
    const errorElement = document.getElementById(`demo${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}Error`);
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
      errorElement.style.color = '#DC2626';
    }
  }
}

/**
 * Clear demo field error
 */
function clearDemoFieldError(field) {
  if (field) {
    field.classList.remove('form-control--invalid');
    
    const fieldName = field.name;
    const errorElement = document.getElementById(`demo${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}Error`);
    if (errorElement) {
      errorElement.style.display = 'none';
      errorElement.textContent = '';
    }
  }
}

/**
 * Show success message after demo form submission
 */
function showDemoSuccessMessage() {
  // Create success message element
  const successMessage = document.createElement('div');
  successMessage.className = 'demo-success-message';
  successMessage.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border: 2px solid #28a745;
    border-radius: 12px;
    padding: 30px;
    text-align: center;
    z-index: 10000;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    max-width: 400px;
    width: 90%;
  `;
  
  successMessage.innerHTML = `
    <div class="success-content">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#28a745" stroke-width="2" style="margin-bottom: 16px;">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22,4 12,14.01 9,11.01"></polyline>
      </svg>
      <h3 style="color: #28a745; font-size: 24px; font-weight: 600; margin-bottom: 12px; margin-top: 0;">Thank you!</h3>
      <p style="color: #6c757d; font-size: 16px; line-height: 1.6; margin: 0;">We'll contact you soon to schedule your demo.</p>
    </div>
  `;

  document.body.appendChild(successMessage);

  // Remove after 3 seconds
  setTimeout(() => {
    if (successMessage && successMessage.parentNode) {
      successMessage.remove();
    }
  }, 3000);
}

// Expose function to global scope
window.initDemoForm = initDemoForm;
